/* Walnut homepage + PDP rebuild (Proud, Oct 2026). Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var d = document, de = d.documentElement;
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var mq = matchMedia('(max-width:899px)');
  var $$ = function (s, r) { return [].slice.call((r || d).querySelectorAll(s)); };
  /* lock page scroll while an overlay is open; html.wm-ovl-open also hides floating app launchers (chat) via wm.css */
  function lock(o) { de.style.overflow = o ? 'hidden' : ''; d.body.style.overflow = o ? 'hidden' : ''; de.classList.toggle('wm-ovl-open', !!o); }
  function playV(v) { if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* rail arrows */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('.wm-rail__nav button'); if (!b) return;
    var root = d.getElementById(b.parentNode.dataset.for); if (!root) return;
    var tr = $$('.wm-rail__track', root).filter(function (x) { return x.offsetParent; })[0];
    if (tr) tr.scrollBy({ left: b.dataset.dir * tr.clientWidth * 0.75, behavior: rm ? 'auto' : 'smooth' });
  });

  /* tabs (ARIA tablist with arrow keys) */
  $$('.wm-tabs[role=tablist]').forEach(function (list) {
    var tabs = $$('[role=tab]', list);
    function sel(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = d.getElementById(x.getAttribute('aria-controls')); if (!p) return;
        var lz = on && p.querySelector('template[data-wm-lazy]'); if (lz) lz.replaceWith(lz.content.cloneNode(true));
        p.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (k === 'Home') n = tabs[0];
        if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); sel(n, true); }
      });
    });
  });

  /* in-view video playback: muted, looping, sources attached only near the viewport */
  var vids = $$('video[data-src]');
  vids.forEach(function (v) { v.addEventListener('playing', function () { v.classList.add('on'); }); });
  if (!rm && !saveData && 'IntersectionObserver' in window && vids.length) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target, sec = v.closest('[data-autoplay]');
        if (sec && sec.dataset.autoplay === 'false') return;
        if (e.isIntersecting) playV(v); else if (!v.paused) v.pause();
      });
    }, { rootMargin: '120px 0px', threshold: 0.2 });
    var startV = function () { vids.forEach(function (v) { vio.observe(v); }); };
    if (d.readyState === 'complete') setTimeout(startV, 200); else addEventListener('load', function () { setTimeout(startV, 200); });
  }

  /* shoppable video modal (desktop modal, mobile full-screen player) */
  $$('[data-wm-videos]').forEach(function (sec) {
    var vm = sec.querySelector('.wm-vm'); if (!vm) return;
    d.body.appendChild(vm); /* portal so position:fixed is never trapped */
    var vmv = vm.querySelector('video'), side = vm.querySelector('.wm-vm__side'), cnt = vm.querySelector('.wm-vm__cnt');
    var box = vm.querySelector('.wm-vm__box'), bg = vm.querySelector('.wm-vm__bg');
    var tpls = $$('.wm-vt', sec), n = tpls.length, cur = -1, last = null, sw = 0, railPaused = [];
    function load(i, handle) {
      cur = (i + n) % n; var t = tpls[cur];
      side.innerHTML = ''; side.appendChild(t.content.cloneNode(true));
      vmv.poster = t.dataset.p; vmv.src = t.dataset.v; cnt.textContent = (cur + 1) + ' / ' + n;
      if (!rm) playV(vmv);
      /* highlight the product that was tapped on the tile and bring it into view */
      var hit = handle && side.querySelector('li[data-p="' + handle + '"]');
      if (hit) {
        hit.setAttribute('aria-current', 'true');
        requestAnimationFrame(function () { hit.scrollIntoView(mq.matches ? { inline: 'center', block: 'nearest' } : { block: 'nearest' }); });
      }
    }
    function open(i, dir, handle) {
      if (!vm.hidden && mq.matches && dir && !rm) {
        vmv.style.setProperty('--sd', dir); vmv.classList.add('swp'); clearTimeout(sw);
        sw = setTimeout(function () { load(i); vmv.style.setProperty('--sd', -dir); requestAnimationFrame(function () { vmv.classList.remove('swp'); }); }, 200);
        return;
      }
      var first = vm.hidden; load(i, handle);
      if (first) {
        /* pause the rail videos behind the player; they resume on close */
        railPaused = $$('video', sec).filter(function (v) { return !v.paused; });
        railPaused.forEach(function (v) { v.pause(); });
        vm.hidden = false; lock(true); void vm.offsetWidth; vm.classList.add('open'); vm.querySelector('.wm-vm__x').focus({ preventScroll: true });
      }
    }
    function close() {
      if (vm.hidden) return; vm.classList.remove('open', 'drag');
      var done = function () {
        box.style.transform = ''; bg.style.opacity = ''; vm.hidden = true; vmv.pause(); vmv.removeAttribute('src'); vmv.load(); lock(false);
        railPaused.forEach(playV); railPaused = [];
        if (last) last.focus({ preventScroll: true });
      };
      if (mq.matches && !rm) setTimeout(done, 300); else done();
    }
    /* the whole tile opens the video view: poster, product row, thumbnail, name, price and "+N more" */
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('.wm-vc__btn, .wm-vc__prod'); if (!b) return;
      e.preventDefault(); last = b; open(+b.dataset.i, 0, b.dataset.p);
    });
    vm.addEventListener('click', function (e) {
      if (e.target.closest('[data-vclose]')) close();
      var nb = e.target.closest('[data-d]'); if (nb) open(cur + +nb.dataset.d, +nb.dataset.d);
    });
    vm.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') { /* focus trap */
        var f = $$('a[href],button:not([disabled])', vm).filter(function (x) { return x.offsetParent; });
        if (!f.length) return; var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && d.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    addEventListener('keydown', function (e) {
      if (vm.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') open(cur + 1, 1);
      if (e.key === 'ArrowLeft') open(cur - 1, -1);
    });
    /* mobile gestures: swipe down to close, left/right for next/previous; the product strip scrolls on its own */
    var x0 = null, y0, dx, dy, ax, t0;
    vm.addEventListener('touchstart', function (e) {
      if (!mq.matches || e.touches.length > 1 || e.target.closest('.wm-vm__side,.wm-vm__x')) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = dy = 0; ax = null; t0 = Date.now();
    }, { passive: true });
    vm.addEventListener('touchmove', function (e) {
      if (x0 == null) return;
      dx = e.touches[0].clientX - x0; dy = e.touches[0].clientY - y0;
      if (!ax && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) ax = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
      if (ax === 'y' && dy > 0) { vm.classList.add('drag'); box.style.transform = 'translate3d(0,' + dy + 'px,0)'; bg.style.opacity = Math.max(0, 1 - dy / innerHeight * 1.4); }
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    vm.addEventListener('touchend', function () {
      if (x0 == null) return; var fast = Date.now() - t0 < 300; vm.classList.remove('drag');
      if (ax === 'y') {
        if (dy > innerHeight * 0.18 || (fast && dy > 60)) { box.style.transform = 'translate3d(0,100%,0)'; bg.style.opacity = '0'; setTimeout(close, 0); }
        else { box.style.transform = ''; bg.style.opacity = ''; }
      } else if (ax === 'x' && (Math.abs(dx) > 60 || (fast && Math.abs(dx) > 30))) { var dr = dx < 0 ? 1 : -1; open(cur + dr, dr); }
      x0 = null;
    }, { passive: true });
  });

  /* reveal on scroll (opacity/transform only) */
  var rv = $$('.wm-rv');
  if (!rm && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else rv.forEach(function (el) { el.classList.add('in'); });

  /* ---------------- PDP ---------------- */
  var pdp = d.querySelector('[data-wm-pdp]');
  if (!pdp) return;
  var DATA = JSON.parse(pdp.querySelector('script[data-wm-variants]').textContent);
  var money = function (c) { return DATA.money.replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); };

  /* gallery dots + counter */
  var gt = pdp.querySelector('.wm-gal__track'), gc = pdp.querySelector('.wm-gal__cnt'), dots = $$('.wm-gal__dots i', pdp), gi = 0, gn = gt ? gt.children.length : 0;
  if (gt) gt.addEventListener('scroll', function () {
    var i = Math.round(gt.scrollLeft / gt.clientWidth);
    if (i !== gi) { gi = i; if (gc) gc.textContent = (i + 1) + ' / ' + gn; dots.forEach(function (x, k) { x.classList.toggle('on', k === i); }); }
  }, { passive: true });

  /* lightbox zoom */
  var lb = d.querySelector('.wm-lb');
  if (lb && gt) {
    d.body.appendChild(lb);
    var lt = lb.querySelector('.wm-lb__track'), lc = lb.querySelector('.wm-lb__cnt'), lits = lt.children, ln = lits.length, llast = null;
    var lbIdx = function () { return Math.round(lt.scrollLeft / lt.clientWidth); };
    var lbOpen = function (i) {
      $$('img[data-src]', lt).forEach(function (im) { im.src = im.dataset.src; im.removeAttribute('data-src'); });
      lb.classList.add('open'); lb.setAttribute('aria-hidden', 'false'); lock(true);
      lt.scrollLeft = i * lt.clientWidth; lc.textContent = (i + 1) + ' / ' + ln; lb.querySelector('.wm-lb__x').focus({ preventScroll: true });
    };
    var lbClose = function () { lb.classList.remove('open'); lb.setAttribute('aria-hidden', 'true'); lock(false); [].forEach.call(lits, function (x) { x.classList.remove('z'); }); if (llast) llast.focus({ preventScroll: true }); };
    gt.addEventListener('click', function (e) { var b = e.target.closest('[data-lb]'); if (!b) return; llast = b; lbOpen(+b.dataset.lb); });
    lt.addEventListener('scroll', function () { lc.textContent = (lbIdx() + 1) + ' / ' + ln; }, { passive: true });
    lt.addEventListener('click', function (e) {
      var it = e.target.closest('.wm-lb__it'); if (!it || e.target.tagName !== 'IMG') return;
      var r = e.target.getBoundingClientRect();
      e.target.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100) + '%');
      e.target.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100) + '%');
      it.classList.toggle('z');
    });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.wm-lb__x')) lbClose();
      var nb = e.target.closest('.wm-lb__nav');
      if (nb) { [].forEach.call(lits, function (x) { x.classList.remove('z'); }); lt.scrollTo({ left: Math.max(0, Math.min(ln - 1, lbIdx() + +nb.dataset.d)) * lt.clientWidth, behavior: rm ? 'auto' : 'smooth' }); }
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('open')) lbClose(); });
  }

  /* sheets (size sheet, size guide) */
  var lastF = null;
  $$('.wm-sheet', pdp).forEach(function (s) { d.body.appendChild(s); });
  var szS = d.querySelector('.wm-sheet--size'), sgS = d.querySelector('.wm-sheet--guide');
  function openSheet(s) { if (!s) return; lastF = d.activeElement; s.classList.add('open'); s.setAttribute('aria-hidden', 'false'); lock(true); var x = s.querySelector('.wm-x'); if (x) x.focus({ preventScroll: true }); }
  function closeSheet(s) { s.classList.remove('open'); s.setAttribute('aria-hidden', 'true'); if (!d.querySelector('.wm-sheet.open')) lock(false); if (lastF) lastF.focus({ preventScroll: true }); }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-guide]')) { e.preventDefault(); if (szS && szS.classList.contains('open')) closeSheet(szS); openSheet(sgS); }
    var c = e.target.closest('[data-sclose]'); if (c) closeSheet(c.closest('.wm-sheet'));
  });
  addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.wm-sheet.open').forEach(closeSheet); });

  /* size selection, synced across buy box, sticky bar and size sheet */
  var form = pdp.querySelector('form[action*="/cart/add"]'), idIn = form && form.querySelector('[name=id]');
  var msg = pdp.querySelector('.wm-opt__msg'), szSel = pdp.querySelector('.wm-szsel');
  var atc = pdp.querySelector('.wm-atc[type=submit]'), sAtc = d.querySelector('.wm-sbar .wm-atc');
  var sel = DATA.needsSize ? null : DATA.variants[0];
  function setPrices(v) {
    $$('[data-wm-price]').forEach(function (el) { el.innerHTML = v.priceHtml; });
    $$('[data-wm-ap]').forEach(function (el) { el.textContent = money(Math.ceil(v.paid / 4)); });
    $$('[data-wm-pts]').forEach(function (el) { el.textContent = Math.floor(v.paid * 2 / 100); });
    if (atc) atc.textContent = DATA.atcLabel + ' · ' + money(v.paid);
  }
  /* back in stock (4 Nov 2026): sold-out sizes can be picked so Klaviyo's "Notify me" button shows in .wm-buy */
  var pb = form && form.querySelector('.wm-payment');
  function notify() {
    if (szS && szS.classList.contains('open')) closeSheet(szS);
    var kb = $$('.wm-buy button', pdp).filter(function (b) { return !b.classList.contains('wm-atc') && !b.closest('.wm-appslot') && /notify/i.test(b.textContent); })[0];
    if (kb) kb.click();
    else { var o = pdp.querySelector('.wm-buy'); if (o) o.scrollIntoView({ block: 'center', behavior: rm ? 'auto' : 'smooth' }); }
  }
  function pick(id) {
    var v = DATA.variants.filter(function (x) { return String(x.id) === String(id); })[0]; if (!v) return;
    sel = v; if (idIn) idIn.value = v.id;
    $$('.wm-sz').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.id) === String(v.id)); });
    if (szSel) szSel.textContent = v.label + (v.available ? '' : ' (sold out)');
    if (msg) msg.classList.remove('show');
    setPrices(v);
    if (!v.available && atc) atc.textContent = 'Sold out';
    if (sAtc) sAtc.textContent = v.available ? DATA.atcLabel : 'Notify me';
    $$('[data-wm-add]').forEach(function (b) { b.textContent = v.available ? DATA.atcLabel : 'Notify me when it\'s back'; });
    if (pb) pb.style.display = v.available ? '' : 'none';
    var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
  }
  d.addEventListener('click', function (e) { var b = e.target.closest('.wm-sz'); if (!b || b.disabled) return; pick(b.dataset.id); });
  function need() {
    if (szS && szS.classList.contains('open')) { var m2 = szS.querySelector('.wm-sizes'); if (m2 && m2.animate && !rm) m2.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 260 }); return; }
    if (msg) msg.classList.add('show');
    var o = pdp.querySelector('.wm-sizeopt'); if (o) o.scrollIntoView({ block: 'center', behavior: rm ? 'auto' : 'smooth' });
  }
  /* block submit / Shop Pay until an in-stock size is chosen (capture phase runs before the theme's product-form) */
  if (form) {
    form.parentNode.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!sel) { e.preventDefault(); e.stopImmediatePropagation(); need(); return; }
      if (!sel.available) { e.preventDefault(); e.stopImmediatePropagation(); notify(); return; }
      idIn.value = sel.id;
      if (szS && szS.classList.contains('open')) closeSheet(szS);
    }, true);
    if (pb) pb.addEventListener('click', function (e) { if (!sel || !sel.available) { e.preventDefault(); e.stopPropagation(); if (sel) notify(); else need(); } }, true);
  }
  $$('[data-wm-add]').forEach(function (b) {
    b.addEventListener('click', function () { if (!sel) return need(); if (!sel.available) return notify(); if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click(); });
  });
  if (sAtc) sAtc.addEventListener('click', function () { if (sel) { if (!sel.available) return notify(); if (form.requestSubmit) form.requestSubmit(); else atc.click(); } else openSheet(szS); });
  /* a size passed in the link (?variant=) is selected on load, including a sold-out one */
  var qv = new URL(location.href).searchParams.get('variant');
  var qb = qv && DATA.needsSize && pdp.querySelector('.wm-sz[data-id="' + qv + '"]');
  if (qb && !qb.disabled) pick(qv);

  /* sticky mobile bar: shows once the main buy button has scrolled out of view */
  var sbar = d.querySelector('.wm-sbar'), buy = pdp.querySelector('.wm-buy');
  if (sbar && buy && 'IntersectionObserver' in window) {
    d.body.appendChild(sbar);
    new IntersectionObserver(function (es) {
      var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      sbar.classList.toggle('show', show); sbar.setAttribute('aria-hidden', !show); if (sAtc) sAtc.tabIndex = show ? 0 : -1;
    }).observe(buy);
  }

  /* colour swatches from the Rubik combined-listings data already on the page (no store writes) */
  var sw = pdp.querySelector('[data-wm-swatches]');
  if (sw) {
    var src = d.querySelector('script[data-rubik-swatch-product-handle="' + sw.dataset.handle + '"]');
    try {
      var g = src && JSON.parse(src.textContent).groups.filter(function (x) { return x.swatches && x.swatches.length > 1; })[0];
      if (g) {
        var list = sw.querySelector('.wm-sw'), cnt2 = sw.querySelector('[data-wm-colours]');
        list.innerHTML = g.swatches.map(function (s) {
          var img = (s.cardFeaturedImage || s.featuredImage || '').replace(/width=\d+/, 'width=120');
          var label = (s.optionValue || '').replace(/"/g, '&quot;');
          return '<a href="' + (s.isCurrent ? '#' : s.productUrl) + '"' + (s.isCurrent ? ' aria-current="true"' : '') + ' aria-label="' + label + '" title="' + label + '"><img src="' + img + '" alt="" width="52" height="65" loading="lazy"></a>';
        }).join('');
        if (cnt2) cnt2.textContent = g.swatches.length + ' colours';
        sw.hidden = false;
      }
    } catch (err) {}
  }

  /* Complete the look + You may also like via the Section Rendering API */
  $$('[data-wm-recs]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (h) {
      var t = d.createElement('div'); t.innerHTML = h;
      var inner = t.querySelector('[data-wm-recs-inner]');
      if (inner && inner.querySelector('.wm-card')) { el.innerHTML = inner.innerHTML; el.hidden = false; }
      else if (el.dataset.fallback !== 'true') el.remove();
      else el.hidden = false;
    }).catch(function () {});
  });
})();